import { formatDate } from '@angular/common';
import { Component, Inject, LOCALE_ID, ViewChild } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { MatLegacyPaginator as MatPaginator } from '@angular/material/legacy-paginator';
import { MatPaginatorIntl } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import moment from 'moment';
import { NgxSpinnerService } from 'ngx-spinner';
import { debounceTime } from 'rxjs/operators';
import { ClaveService } from 'src/app/_services/clave.service';
import { CsvgenerateService } from 'src/app/_services/csvgenerate/csvgenerate.service';
import { NotificationService } from 'src/app/_services/notification.service';
import { ServicioGeneral } from 'src/app/_services/servicio-general.service';
import { SolicituCustomService } from 'src/app/_services/solicitud-custom.service';
import { SolicitudEmvsService } from 'src/app/_services/solicitud-emvs.service';
import { TokenStorageService } from 'src/app/_services/token-storage.service';
import { BoardAdminComponent } from 'src/app/board-admin/board-admin.component';
import { ListadoTramitesEmvsService } from '../listado-tramites-emvs/listado-tramites-emvs.service';
import { EstadoTramiteReturn, TramiteEmvs } from '../listado-tramites-emvs/tramite-emvs';


export type LogDTO = {
  "Origen": string,
  "Logger": string,
  "Nombre del Hilo": string,
  "Fecha": string,
  "Máquina": string,
  "Mensaje": string,
  "Stack Trace": string
};

@Component({
  selector: 'app-listado-errores-emvs',
  templateUrl: './listado-errores-emvs.component.html',
  styleUrls: ['../listado-tramites-emvs/listado-tramites-emvs.component.scss'],

})
export class ListadoErroresEmvsComponent {


  private readonly columnasBase = [
    "Origen",
    "Logger",
    "Nombre del Hilo",
    "Fecha",
    "Máquina",
    "Stack Trace",
    "Mensaje",
  ];
  displayedColumns: string[] = [...this.columnasBase];
  private readonly colKeys: Record<string, string> = {
    'Origen': 'ERRORES.COL.ORIGEN',
    'Logger': 'ERRORES.COL.LOGGER',
    'Nombre del Hilo': 'ERRORES.COL.HILO',
    'Fecha': 'ERRORES.COL.FECHA',
    'Máquina': 'ERRORES.COL.MAQUINA',
    'Stack Trace': 'ERRORES.COL.STACK',
    'Mensaje': 'ERRORES.COL.MENSAJE',
    'Acciones': 'ERRORES.COL.ACCIONES',
  };
  dataSource = new MatTableDataSource<LogDTO>();

  get totalLogs(): number { return this.dataSource?.data?.length || 0; }
  get logsMostrados(): number { return this.dataSource?.filteredData?.length ?? this.totalLogs; }

  request: TramiteEmvs[];
  requestCsv: any[];

  user = this.tokenStorageService.getUser()
  userId = this.user["id"]
  isAdmin: boolean = Math.max(...this.user["rol"]) > 1;
  idCurrentPdf: number = 0;
  notificacionesDto: LogDTO[] = [];
  isInProgress: boolean = false;
  actionProgres: boolean = false;
  cargaTotal: boolean = false;
  pdfsDownload = [];
  display: string = 'none';
  diasCaducidad: string = localStorage.getItem('tramiteMaxDays');
  estadoTramiteReturn = EstadoTramiteReturn;
  deleteCurrenTramite: TramiteEmvs = {
    id: -1
  }
  selectedTramite: any;
  selectedOpcion: String = 'Firmar con Autofirma';
  displayFirma: string = 'none';
  filteredValues: any =
    {
      DNI: '',
      Nombre: '',
      FechaDesde: '',
      FechaHasta: '',
      Estado: '',
      PasoTramite: ''
    };
  filtroIP = new FormControl();
  filtroMensaje = new FormControl();
  filtroFecha = new FormGroup({
    start: new FormControl(),
    end: new FormControl(),
  })
  filtroCargaTotal = new FormControl(false);
  cargandoTramites: boolean = false;
  filtersOpen: boolean = false;

  get activeFilterCount(): number {
    let count = 0;
    if (this.filteredValues['IP']) count++;
    if (this.filteredValues['Mensaje']) count++;
    if (this.filteredValues['FechaDesde']) count++;
    if (this.filtroCargaTotal.value) count++;
    return count;
  }
  tabTraduccion = {
    "personales-tab": "Datos solicitante",
    "representacionReducida-tab": "Datos representante",
    "instancia-tab": "Expone/Solicita",
    "politicas-tab": "Política de privacidad",
    "representacion-tab": "Datos representante",
    "circunstancias-tab": "Circunstancias económicas",
    "unidad-tab": "Datos unidad familiar",
    "distritos-tab": "Distritos municipales",
    "vulnerabilidad-tab": "Situación vulnerabilidad",
    "autorizacion-tab": "Autorización de consulta",
    "ficheros-tab": "Carga de ficheros",
    "puestos-tab": "Puestos solicitados"
  };
  tabTraduccionB = {
    "Datos solicitante": "personales-tab",
    "Datos representante": "representacion",
    "Expone/Solicita": "instancia-tab",
    "Política de privacidad": "politicas-tab",
    "Circunstancias económicas": "circunstancias-tab",
    "Datos unidad familiar": "unidad-tab",
    "Distritos municipales": "distritos-tab",
    "Situación vulnerabilidad": "vulnerabilidad-tab",
    "Autorización de consulta": "autorizacion-tab",
    "Carga de ficheros": "ficheros-tab",
    "Puestos solicitados": "puestos-tab"
  };
  listadoTipoEnvio: any = [];
  listadoPasos: any = [{ label: '' }];
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  mensajeSpinner: string;
  constructor(
    private listadoTramitesService: ListadoTramitesEmvsService,
    private _solicitudEmvsService: SolicitudEmvsService,
    private tokenStorageService: TokenStorageService,
    private _csvgenerate: CsvgenerateService,
    private _notificationSvc: NotificationService,
    private paginatorIntl: MatPaginatorIntl,
    private _boardAdmin: BoardAdminComponent,
    private _router: Router,
    private _servicioGeneral: ServicioGeneral,
    private _claveService: ClaveService,
    private route: ActivatedRoute,
    private spinner: NgxSpinnerService,
    private _solicituCustomService: SolicituCustomService,
    private notificationSvc: NotificationService,
    public translate: TranslateService,
    @Inject(LOCALE_ID) public locale: string
  ) {
    this.traduccionPaginator();
  }

  ngOnInit(): void {
    this.cargarLogs();
    this.cargaTotal = false;
    this.filtroIP.valueChanges.pipe(debounceTime(400)).subscribe((valorfiltroIP) => {
      this.filteredValues['IP'] = valorfiltroIP;
      this.cargarLogs();
    });

    this.filtroMensaje.valueChanges.pipe(debounceTime(400)).subscribe((valorfiltroMensaje) => {
      this.filteredValues['Mensaje'] = valorfiltroMensaje;
      this.cargarLogs();
    });
    this.filtroFecha.controls['start'].valueChanges.pipe(debounceTime(400)).subscribe((valorFiltroFechaDesde) => {
      this.filteredValues['FechaDesde'] = valorFiltroFechaDesde;
      this.cargarLogs();
    });
    this.filtroFecha.controls['end'].valueChanges.pipe(debounceTime(400)).subscribe((valorFiltroFechaHasta) => {
      this.filteredValues['FechaHasta'] = valorFiltroFechaHasta;
      this.cargarLogs();
    });

    this.filtroCargaTotal.valueChanges.subscribe((valorFiltroPaso) => {
      this.cargaTotal = valorFiltroPaso;
      this.cargarLogs();
    });


  }


  cargarLogs() {
    this.notificacionesDto = [];
    this.mostrarSpinnerMsg(this.translate.instant('COMMON.LOADING'));
    this._servicioGeneral.getLogsPage(
      this.cargaTotal,
      this.filteredValues['FechaDesde'],
      this.filteredValues['FechaHasta'],
      this.filteredValues['IP'],
      this.filteredValues['Mensaje'],
    ).subscribe({
      next: (data) => {
        this.request = data;
        console.log("data");
        console.log(data);
        data
          .forEach(miLog => {

            var LogDTO: LogDTO = {
              "Origen": miLog.origen,
              "Logger": miLog.logger,
              "Mensaje": miLog.message,
              "Nombre del Hilo": miLog.threadName,
              "Fecha": miLog.timestamp,
              "Máquina": miLog.maquina,
              "Stack Trace": miLog.stakTrace


            };
            this.notificacionesDto.push(LogDTO);

          });
        console.log(this.notificacionesDto)
        this.actualizarColumnasVisibles();
        this.dataSource = new MatTableDataSource(this.notificacionesDto);
        this.dataSource.filterPredicate = this.customFilterPredicate();
        this.dataSource.sort = this.sort;
        this.dataSource.paginator = this.paginator;
        this.dataSource.sortingDataAccessor =
          (data: object, sortHeaderId: string): string | number => {
            const propPath = sortHeaderId.split('.');
            const value: any = propPath
              .reduce((curObj, property) => curObj[property], data);
            return !isNaN(value) ? Number(value) : value;
          };
        this.cargandoTramites = false;

        this.ocultarSpinner();


      },
      error: (err) => {
        console.log(err);
        this._notificationSvc.error(this.translate.instant('COMMON.ERROR'), this.translate.instant('ERRORES.MSG.LOAD_FAIL'), 3000);
        this.cargandoTramites = false;
        this.ocultarSpinner();
      },
    })

  }


  dateRangeChange(dateRangeStart: HTMLInputElement, dateRangeEnd: HTMLInputElement) {
    this.filteredValues['FechaDesde'] = dateRangeStart?.value;
    this.filteredValues['FechaHasta'] = dateRangeEnd?.value;
    this.dataSource.filter = JSON.stringify(this.filteredValues);
  }
  customFilterPredicate() {
    return function (data: LogDTO, filter: string): boolean {
      let searchString = JSON.parse(filter);
      var enRango = true;
      if (searchString.FechaDesde) {
        let compareDate = new Date(data['Fecha']);
        compareDate.setHours(0, 0, 0, 0);
        let startDate = new Date(searchString.FechaDesde);
        startDate.setHours(0, 0, 0, 0);
        if (compareDate.getTime() >= startDate.getTime()) {
          enRango = true;
        }
        else {
          enRango = false;
        }
      }
      if (searchString.FechaHasta && enRango) {
        let compareDate = new Date(data['Fecha']);
        compareDate.setHours(0, 0, 0, 0);
        let endDate = new Date(searchString.FechaHasta);
        endDate.setHours(23, 59, 59, 0);
        if (compareDate.getTime() <= endDate.getTime()) {
          enRango = true;
        }
        else {
          enRango = false;
        }
      }
      return enRango
        && (!searchString.DNI || data['IP']?.toString().toLowerCase().trim().indexOf(searchString.DNI?.toLowerCase().trim()) !== -1)
        && (!searchString.Nombre || data['Nombre del trámite']?.toString().toLowerCase().trim().toLowerCase().indexOf(searchString.Nombre?.toLowerCase().trim()) !== -1)
        && (!searchString.Estado || data['Estado']?.toString().toLowerCase().trim().toLowerCase().indexOf(searchString.Estado?.toLowerCase().trim()) !== -1)
        && (!searchString.PasoTramite || (data['Último paso trámite'] && data['Último paso trámite']?.toString().toLowerCase().trim().indexOf(searchString.PasoTramite?.toLowerCase().trim()) !== -1))
        ;
    }
  }

  formatoFecha(date) {
    if (date) {
      let month = (date[1] < 10) ? '0' + date[1] : date[1];
      let day = (date[2] < 10) ? '0' + date[2] : date[2];
      let year = date[0];
      let hour = (date[3] < 10) ? '0' + date[3] : date[3];
      let min = (date[4] < 10) ? '0' + date[4] : date[4];
      let seg = (date[5]) ? ((date[5] < 10) ? '0' + date[5] : date[5]) : '00';
      return [year, month, day].join('-').concat('T' + [hour, min, seg].join(':') + '.000Z');
    }
    return ''
  }
  formatTimestamp(time: any) {
    try {
      return moment(time).format('DD-MM-YYYY HH:mm')
    }
    catch (error) {
      return '';
    }
  }
  formatDate(date: Date) {
    return formatDate(date, 'dd-MM-yyyy HH:mm', this.locale, 'GMT');
  }
  formatDateWithoutHour(date: Date) {
    return formatDate(date, 'dd-MM-yyyy', this.locale, 'GMT');
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();

    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }




  private traduccionPaginator(): void {
    this.paginatorIntl.itemsPerPageLabel = "Registros por página";
    this.paginatorIntl.firstPageLabel = '';
    this.paginatorIntl.previousPageLabel = '';
    this.paginatorIntl.nextPageLabel = '';
    this.paginatorIntl.lastPageLabel = '';
    this.paginatorIntl.getRangeLabel = (page: number, pageSize: number, length: number) => {
      if (length === 0 || pageSize === 0) {
        return `0 de ${length}`;
      }
      length = Math.max(length, 0);
      const startIndex = page * pageSize;
      const endIndex = startIndex < length ? Math.min(startIndex + pageSize, length) : startIndex + pageSize;
      return `${startIndex + 1} - ${endIndex} de ${length}`;
    };
  }






  public valuesEnum(object): boolean {
    return Object.values(this.estadoTramiteReturn).includes(object)
  }

  signTramite(tramite: any) {
    this.displayFirma = 'block';
    this.selectedTramite = tramite;
  }


  limpiarParametros() {
    this._router.navigate([], {
      queryParams: {
        'rId': null,
        'a': null,
        't': null,
      },
      queryParamsHandling: 'merge'
    });
  }
  cargarMas() {
    const newSize = this.paginator.pageSize + 10;
    this.paginator.pageSize = newSize;
    this.dataSource.paginator = this.paginator;
  }

  clearFilters() {
    this.filtroIP.setValue('');
    this.filtroMensaje.setValue('');
    this.filtroFecha.reset();
    this.filtroCargaTotal.setValue(false);
  }

  mostrarSpinnerMsg(mensaje: string) {
    this.mensajeSpinner = mensaje;
    this.spinner.show('litado_errores_spinner');
    setTimeout(() => {
      /** spinner ends after 5 seconds */
      this.spinner.hide('litado_errores_spinner');
    }, 60000);
  }
  ocultarSpinner() {
    this.spinner.hide('litado_errores_spinner');
  }
  exportarCsv() {
    setTimeout(() => {
      /** spinner ends after 5 seconds */
      this._csvgenerate.generateCsvLogs(this.request, this.filteredValues);
      this.ocultarSpinner();
    }, 100);
  }

  downloadJustificante(idNextcloud: number) {
    console.log(idNextcloud)
    this.isInProgress = true;
    this.actionProgres = true;
    this.pdfsDownload.push(idNextcloud);

    this.listadoTramitesService.downloadJustificanteB64(idNextcloud).subscribe({
      next: (fichero) => {
        const linkSource = 'data:application/pdf;base64,' + fichero.Result;
        const downloadLink = document.createElement("a");
        const fileName = "tramite.pdf";

        downloadLink.href = linkSource;
        downloadLink.download = fileName;
        downloadLink.click();

        this._notificationSvc.success(this.translate.instant('COMMON.DONE'), this.translate.instant('TRAMITES.MSG.PDF_OK'), 3000);
        this.isInProgress = false;

        const index: number = this.pdfsDownload.indexOf(idNextcloud);
        this.pdfsDownload.splice(index, 1);
        this.actionProgres = false;
      },
      error: (error) => {
        //console.log(error);
        this._notificationSvc.error(this.translate.instant('COMMON.ERROR'), this.translate.instant('TRAMITES.MSG.PDF_FAIL'), 3000);

        this.actionProgres = false;
        this.isInProgress = false;
        this.pdfsDownload.splice(this.pdfsDownload.indexOf(idNextcloud), 1);
      }
    });
  }

  copyStackTrace(stackTrace: string) {
    navigator.clipboard.writeText(stackTrace)
      .then(() => this.notificationSvc.info(this.translate.instant('COMMON.INFO'), this.translate.instant('ERRORES.MSG.COPIED'), 2000))
      .catch(err => this.notificationSvc.error(this.translate.instant('COMMON.ERROR'), this.translate.instant('COMMON.ERROR'), 2000));
  }

  colLabel(column: string): string {
    const key = this.colKeys[column];
    return key ? this.translate.instant(key) : column;
  }

  actualizarColumnasVisibles(): void {
    const cols = [...this.columnasBase];
    if (this.hayAccionesEnTabla()) {
      cols.push('Acciones');
    }
    this.displayedColumns = cols;
  }

  hayAccionesEnTabla(): boolean {
    return this.notificacionesDto.some(l => !!l['Stack Trace']);
  }
}
